<script setup>
import { defineProps } from 'vue';

defineProps(['title', 'backHidden']);
</script>

<template>
    <div class="vfm__header">
        <p class="vfm__title">{{ title }}</p>

        <button v-if="!backHidden" type="button" class="vfm__close" @click="$emit('close')">
            <img src="/img/close.svg" />
        </button>
    </div>
</template>

<style lang="scss" scoped>
@import 'resources/sass/variables';

.vfm__header {
    display: flex;
    align-items: center;
    padding: 0 4px 0 16px;
    height: 54px;
    border-bottom: 1px solid rgba(black, 0.1);
    font-size: 18px;
    font-weight: $font-weight-medium;
    color: black;

    p {
        @include custom-ellipsis;
    }
}

.vfm__close {
    @include reset-button;

    display: flex;
    justify-content: center;
    align-items: center;
    flex-shrink: 0;
    margin-left: auto;
    width: 40px;
    height: 40px;

    svg {
        fill: $gray;
    }
}
</style>
